import { Stack, Typography } from '@mui/material';

import AutoStatementImage from './images/AutoStatement.png';

import Dialog from 'modules/common/components/MUI/Dialog';

interface AutoStatementsEligibleModalProps {
    readonly open: boolean;
    readonly onDismiss: (method: 'upload_button' | 'close_modal') => void;
    readonly onEnable: () => void;
    readonly institutionName: string;
    readonly isConnecting: boolean;
}

export default function AutoStatementsEligibleModal({
    open,
    onDismiss,
    onEnable,
    institutionName,
    isConnecting,
}: AutoStatementsEligibleModalProps) {
    return (
        <Dialog
            open={open}
            onClose={() => onDismiss('close_modal')}
            heading={`${institutionName} is eligible for Auto Statements`}
            maxWidth="sm"
            fullWidth
            negativeAction={{
                label: 'I prefer to upload monthly',
                onClick: () => onDismiss('upload_button'),
                variant: 'text',
            }}
            positiveAction={{
                label: 'Enable Auto Statements',
                onClick: onEnable,
                loading: isConnecting,
            }}>
            <Stack spacing={3}>
                <img src={AutoStatementImage} alt="Auto Statements illustration" style={{ width: '100%' }} />

                <Typography variant="body1">
                    Stop manual statement uploads by enabling Auto Statements. Once enabled, we&apos;ll securely sync
                    your statement data to reconcile your accounts and ensure your books stay audit-ready and
                    issue-free.
                </Typography>
            </Stack>
        </Dialog>
    );
}
